// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__ZYkef","row":"styles_row__18uC9"};